module.exports = new __parcel__URL__("written.8ff0315d.png").toString();